// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2_LgG","title":"Header_title__2ECa-","left":"Header_left__1LQ8e","clinicName":"Header_clinicName__1ZJxZ"};